import { SHIPPER_GUIDE_API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import { SpotQuoteRepository } from '../infra/SpotQuoteRepository'

type SubmitSpotQuoteParams = {
  id: string
  flatRate: number
  notes?: string
}

export type SubmitBulkSpotQuoteParams = {
  inviteUuid: string
  rates: Array<SubmitSpotQuoteParams>
}

export type SubmitBulkSpotQuoteFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
}

export function submitBulkSpotQuoteFactory({
  spotQuoteRepository,
}: SubmitBulkSpotQuoteFactoryDependencies) {
  return async function submit(
    params: SubmitBulkSpotQuoteParams,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await spotQuoteRepository.submitBulkSpotQuote(params, config)
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not submit the bulk spot quote', { cause: error as Error })
    }
  }
}

export function submitBulkSpotQuote(
  params: SubmitBulkSpotQuoteParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = new HttpClient(SHIPPER_GUIDE_API_URL)
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const submit = submitBulkSpotQuoteFactory({ spotQuoteRepository })

  return submit(params, config)
}
